/**
 * Get the possible color values for the word cloud
 *
 * @returns {Array}
 */
export default function wordCloudColors() {
  return ['#9d0278', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#4c0bef']
}
